import { Box, Button, Modal, Typography } from "@mui/material"
import { CustomAlertAction, CustomAlertState } from "../controller/custom.alert.controller";
const CustomAlertModal = ({ ctrl }: { ctrl: CustomAlertState & CustomAlertAction }) => {
    return (
        <Modal
            open={ctrl.alert != null}
            onClose={() => ctrl.handleCustomAlert(null)}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflowY: 'auto' }}
        >
            <Box
                sx={{
                    bgcolor: 'white',
                    maxWidth: '500px',
                    minWidth: "300px",
                    borderRadius: '12px',
                    maxHeight: { xs: '90vh' },
                    overflow: 'hidden',
                }}
            >
                <Box>
                    <Box sx={{ width: '100%' }}>
                        <Box pt={ctrl.alert?.important ? 0 : 4} pb={4} alignItems={"center"} display={"flex"} flexDirection={"column"}>
                            <Box bgcolor={"#B43F3F"} width={"100%"} >
                                {ctrl.alert?.important && <Typography py={"10px"} px={"10px"} color={"white"} fontWeight={1} fontStyle={"normal"} fontSize="17px">ຂໍ້ສະເໜີ: {ctrl.alert?.important ?? ""}</Typography>}
                            </Box>
                            <Box pt={ctrl.alert?.important ? 2 : 0} flexDirection={"column"} alignItems={"center"} display={"flex"} px={4}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: "10px" }}>
                                    <Typography fontSize="24px">{ctrl.alert?.title}</Typography>
                                </Box>
                                <Typography fontWeight={1} fontStyle={"normal"} fontSize="16px">{ctrl.alert?.message}</Typography>

                                <Box sx={{ display: 'flex', gap: 2, mt: "20px", width: "100%" }}>
                                    <Button
                                        onClick={() => ctrl.alert?.onNegative ? ctrl.alert?.onNegative() : ctrl.handleCustomAlert(null)}
                                        sx={{ flexGrow: 1, borderRadius: '100px', height: '41px', textWrap: "nowrap" }}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                    >
                                        {ctrl.alert?.negText ?? "CANCEL"}
                                    </Button>
                                    <Button
                                        onClick={() => ctrl.alert?.onPositive ? ctrl.alert?.onPositive() : ctrl.handleCustomAlert(null)}
                                        sx={{ flexGrow: 1, borderRadius: '100px', height: '41px', textWrap: "nowrap" }}
                                        size="small"
                                        fullWidth
                                        variant="contained"
                                    >
                                        {ctrl.alert?.posText ?? "OK"}
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Modal >
    );
}

export default CustomAlertModal;